
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      activeFilter: ``,
      staff: [], // Data from API
      noSquadFound: false,
    };
  },
  computed: {
    dfpOptions () {
      return this.$store.state.config.squad_dfp;
    },
    staffTypes () {
      return this.post.acf.staff_types;
    },
    staffRoles () {
      return this.post.acf.staff_roles;
    },
  },
  mounted () {
    this.getStaffData();
  },
  methods: {
    setFilter (filter) {
      this.activeFilter = filter;
    },
    async getStaffData () {
      const params = {
        include: `staffType,images,staffRole`,
        filter: {
          "staffType.name": this.staffTypes.length ? this.staffTypes.join(`||`) : ``,
          "staffRole.name": this.staffRoles.length ? this.staffRoles.join(`||`) : ``,
        },
      };

      const response = await this.$getStats(`staff`, params);
      if (response) {
        this.staff = response.data;
      } else {
        this.noStaffFound = true;
      }
    },
    getStaffGroup (staffGroup) {
      const group = this.sortStaff(this.staff.filter(staff => staff.staffType.name === staffGroup));
      const hasStaffRole = group.filter(staff => staff.staffRole);
      const noStaffRole = group.filter(staff => !staff.staffRole);
      return [...this.sortStaff(hasStaffRole), ...this.sortStaff(noStaffRole)];
    },
    sortStaff (staff) {
      /* Sort priority:
        - Role (Manager, Coach etc.)
        - Surname
        - First name
      */
      return staff.sort((a, b) => a.staffRole?.priority - b.staffRole?.priority);

      // .sort((a, b) => a.firstName.localeCompare(b.firstName))
      // .sort((a, b) => a.lastName.localeCompare(b.lastName))
      // .sort((a, b) => a.staffRole?.priority - b.staffRole?.priority);
    },
  },
};
